import React, { FC } from 'react';
import styled from 'styled-components';
import { BiSolidStar, BiStar } from 'react-icons/bi';

import { useFavouriteShops } from '../../hooks/use.favourite.shops';

type FavouriteShopButtonProps = {
  shopId: string;
  shopName: string;
};

// Toggle button: a fixed name plus aria-pressed, so screen readers announce the state.
const FavouriteShopButton: FC<FavouriteShopButtonProps> = ({ shopId, shopName }) => {
  const { isFavourite, toggleFavourite } = useFavouriteShops();
  const favourite = isFavourite(shopId);
  return (
    <StarButton
      type='button'
      aria-label={`Favourite ${shopName}`}
      aria-pressed={favourite}
      title={favourite ? 'Remove from favourites' : 'Add to favourites'}
      $favourite={favourite}
      onClick={(event) => {
        event.stopPropagation();
        toggleFavourite(shopId);
      }}
    >
      {favourite ? <BiSolidStar aria-hidden='true' /> : <BiStar aria-hidden='true' />}
    </StarButton>
  );
};

export default FavouriteShopButton;

const StarButton = styled.button<{ $favourite: boolean }>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: ${(props) => (props.$favourite ? '#e5a000' : '#8a8a8a')};
  font-size: 18px;
  cursor: pointer;

  &:hover {
    background: #f1f1f1;
    color: ${(props) => (props.$favourite ? '#c78a00' : '#4a4a4a')};
  }

  &:focus-visible {
    outline: 2px solid #005bd3;
    outline-offset: 1px;
  }
`;
